<div *ngIf ="!isNetCDF && !isFromUrl" class="content" fxLayout="column">
    <p>
        Without prejudice to the applicable
        <a href="https://nucleus.iaea.org/Pages/Others/Disclaimer.aspx"
            target="_blank">Terms and Conditions</a>,
        <br />
        I hereby agree that any use of the data will contain appropriate
        acknowledgement of the data source(s) and the IAEA Marine Radioactivity
        Information System (MARIS).
    </p>
    <p>The preferred form of citation of MARIS is:</p>
    <p>
        <b>
            IAEA MARIS, {{ today | date : 'yyyy' }}. IAEA Marine Radioactivity
            Information System. In: Division of IAEA Marine Environment Laboratories
            [online]. Monaco. [Cited DATE] https://maris.iaea.org
        </b>
    </p>
    <p></p>
    <div>
        <a  class="btn btn-primary" (click)="exportData()">
            Download CSV
            <div *ngIf="show" class="lds-ring" id="loading-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </a>
       
        <a (click)="closeDialog()" class="btn btn-light"> Close </a>
    </div>
</div>

<div *ngIf="isNetCDF" class="content" fxLayout="column">
    <p>
        By downloading data you agree to the MARIS Terms and Conditions
    </p>
    
    <div>
        
        <a  class="btn btn-primary" (click)="exportData()">
            Download NetCDF
            <div *ngIf="show" class="lds-ring" id="loading-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </a>
        <a (click)="closeDialog()" class="btn btn-light"> Close </a>
    </div>
</div>

<div *ngIf="!isNetCDF && isFromUrl" class="content" fxLayout="column">
    <p>
        By downloading data you agree to the MARIS Terms and Conditions
    </p>

    <div>

        <a class="btn btn-primary" (click)="exportData()">
            Download CSV
            <div *ngIf="show" class="lds-ring" id="loading-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </a>
        <a (click)="closeDialog()" class="btn btn-light"> Close </a>
    </div>
</div>
